export const mockOpenTooltip = false;
export const mockOpenDropdown = false;
export const mockNotiDontClose = false;
